import { HHMT_THEME, REMOX_THEME } from 'constants';

export const ETA_IFRAME_HOST = {
  [HHMT_THEME]: `${process.env.REACT_APP_HHMT_WEBFLOW_ETA_URL}`,
  [REMOX_THEME]: `${process.env.REACT_APP_REMOX_WEBFLOW_ETA_URL}`,
};
